const SET_USER_REGISTRY_ERROR = 'setUserRegistryError';
const SET_ADD_TO_REGISTRY_LOADING_STATE = 'setRegistryLoadingState';
const SET_USER_REGISTRY_LOADING_STATE = 'setUserRegistriesLoadingState';
const SET_ADD_TO_REGISTRY_RESPONSE = 'setRegistryResponse';
const SET_ADD_TO_REGISTRY_ERROR_MESSAGE = 'setRegistryErrorMessage';
const SET_USER_REGISTRIES_RESPONSE = 'setUserRegistriesResponse';
const SET_RESET_STATE = 'setResetState';
const SET_SUCCESS_STATE = 'setSuccessState';
const SET_USER_REGISTRY_STATUS_ERROR = 'setUserRegistryStatusError';

export {
  SET_USER_REGISTRY_ERROR,
  SET_ADD_TO_REGISTRY_LOADING_STATE,
  SET_USER_REGISTRY_LOADING_STATE,
  SET_ADD_TO_REGISTRY_RESPONSE,
  SET_ADD_TO_REGISTRY_ERROR_MESSAGE,
  SET_USER_REGISTRIES_RESPONSE,
  SET_RESET_STATE,
  SET_SUCCESS_STATE,
  SET_USER_REGISTRY_STATUS_ERROR,
};
